export const LABEL_DESCRIPTION = "Описание";
export const LABEL_UNKNOWN_ERROR = "Ошибка";
export const LABEL_UNKNOWN_ERROR_SUB = "Что-то пошло не так.";
